{
  "__comment.error.app": "Errore generato nell'app - weblate: copia-incolla senza tradurre questa linea",
  "__comment.error.backend": "Errori generati dal backend - weblate: copia-incolla senza tradurre questa linea",
  "admin.unauthorized": "Non sei autorizzato a fare questa azione",
  "anonymous.request": "Si è verificato un errore. Se il problema persiste, per favore contattaci",
  "app-service.not-connected": "Sembra che non tu non sia connesso a internet.",
  "app-service.unavailable.description": "Un problema di connessione impedisce l'accesso al servizio. Si prega di verificare la connessione di rete. Grazie per la pazienza!",
  "app.accessibility.community": "",
  "app.accessibility.intentions": "",
  "app.accessibility.intentions-theme": "",
  "app.accessibility.messages": "",
  "app.accessibility.unsubscribe-donation-mail": "",
  "app.audio.listen": "Ascoltare l'audio",
  "app.audio.loading-error": "Si è verificato un errore durante il caricamento del file audio",
  "app.avoidance-navigation.content": "Contenuto della pagina",
  "app.banner.goal.goal": "Obiettivo : {amount} donazioni regolari",
  "app.description": "",
  "app.donation.later.i-want": "Voglio fare un'offerta più tardi",
  "app.donation.later.success.toast": "",
  "app.download": "",
  "app.error": "Oops, si è verificato un errore, riprova più tardi.",
  "app.how-to.open-menu": "",
  "app.i-donate": "Dono",
  "app.maintenance": "<strong>Hozana</strong> è in manutenzione.\nAttendi qualche minuto prima di aggiornare il browser per continuare.",
  "app.navigation.events-link": "Gli appuntamenti Hozana !",
  "app.navigation.footer.faq.link": "Domande... e risposte!",
  "app.navigation.footer.guide.all": "Tutti gli articoli delle nostre guide",
  "app.navigation.footer.guide.bible": "Scopro la bibbia",
  "app.navigation.footer.guide.catechism": "Catechismo : le risposte alle tue domande !",
  "app.navigation.footer.guide.feast-days": "Festività cristiane",
  "app.navigation.footer.guide.meditation": "Guida alla meditazione cristiana",
  "app.navigation.footer.guide.miracles": "Scopri i miracoli e le apparizioni",
  "app.navigation.footer.guide.prayer": "Suggerimenti per pregare",
  "app.navigation.footer.guide.rosary": "Guida per recitare il rosario",
  "app.navigation.footer.guide.saints": "Scopro i santi",
  "app.navigation.footer.who.we.are.link": "Chi siamo?",
  "app.navigation.jobs-link": "Offerte di lavoro !",
  "app.navigation.main": "Menu principale",
  "app.navigation.open-menu": "Menu aperto",
  "app.navigation.secondary": "Menu secondario",
  "app.report-abuse.comment": "Segnala questo commento",
  "app.report-abuse.intention": "Segnalare questa intenzione",
  "app.report-abuse.placeholder": "Segnalo questo contenuto perché…",
  "app.report-abuse.reason": "Ti preghiamo di spiegarci i motivi per i quali vuoi segnalare queto contenuto.",
  "app.report-abuse.report": "Segnalare un abuso",
  "app.report-abuse.send": "Segnalare",
  "app.report-abuse.uplift": "",
  "app.report-issue.button": "Segnalo un problema",
  "app.report-issue.thank-you": "Grazie ! il problema è stato segnalato",
  "auth.login.email": "Accedi con l'email",
  "auth.login.login": "Connettersi",
  "auth.otp.code.accessibility-label": "Codice di autenticazione a sei cifre",
  "auth.otp.code.description": "Abbiamo inviato un codice temporaneo a: {email}",
  "auth.otp.code.resend": "Invia nuovamente il codice",
  "auth.otp.code.title": "Controlla la tua email",
  "auth.otp.login.title": "Qual è il tuo indirizzo email?",
  "auth.otp.signup.title": "Come ti chiami?",
  "auth.privacy.notice": "Hozana è gratuita. Consulta i <link>termini e condizioni</link>. Hozana non condividerà mai il tuo indirizzo email con terze parti senza il tuo consenso.",
  "auth.signup.signup": "Creare un account",
  "auth.social.apple": "Accedi con Apple",
  "auth.social.apple.missing-identity-token": "L'accesso con Apple non ha restituito un token di identità",
  "auth.social.google": "Continua con Google",
  "auth.social.google.canceled": "L'accesso con Google è stato annullato",
  "auth.social.google.missing-authorization-code": "L'accesso con Google non ha restituito un codice di autorizzazione",
  "birthdate.invalid": "La data di nascita non è valida",
  "captcha.invalid": "Il test per verificare che non sei un robot é fallito, ti preghiamo di riprovare",
  "captcha.missing": "Clicca su \"Non sono un robot\"",
  "captcha.required": "Riempire il chaptcha",
  "comment.community.unknown": "La comunità é introvabile",
  "comment.delete.delete": "Cancellare il commento",
  "comment.delete.fail.none": "Il commento non é stato cancellato",
  "comment.delete.not.found": "Impossibile trovare il commento da cancellare",
  "comment.form.empty": "Scrivere un commento da pubblicare",
  "comment.id.not-found": "Ci dispiace, non abbiamo potuto visualizzare la risposte a questo commento",
  "comment.not-found": "Il commento non é stato ritrovato",
  "comment.relative.time": "",
  "comment.relative.time.today": "",
  "comment.relative.time.week-day": "",
  "comment.relative.time.yesterday": "",
  "comment.relative.week-day": "",
  "comment.update.not.found": "Il commento da aggiornare é introvabile",
  "comment.write.your-comment": "Il tuo commento",
  "common.error.api.default": "Problema di connessione al server",
  "common.error.unknown": "",
  "common.form.error.captcha.invalid": "Il chaptcha non é valido. Rirova.",
  "common.form.error.captcha.required": "Clicca su \"Non sono un robot\"",
  "common.form.error.email.invalid": "Indirizzo email non valido",
  "common.form.error.fail": "Si é verificato un errore, riprova per favore",
  "common.form.error.field.invalid": "Contenuto errato, correggi per favore",
  "common.form.error.field.required": "Riempi questo spazio",
  "common.form.error.message.required": "Messaggio richiesto",
  "common.form.error.password-is-name": "La tua password dev'essere diversa dal tuo nome",
  "common.form.error.password.different": "Conferma con la stessa password",
  "common.form.error.subject.required": "Oggetto richiesto",
  "common.word.start-today": "Comincia oggi",
  "common.word.start-tomorrow": "Comincia domani",
  "common.word.tomorrow": "Domani",
  "communities.categories": "",
  "communities.categories.all": "",
  "communities.for-you.edit": "",
  "communities.for-you.empty": "",
  "communities.for-you.settings": "",
  "communities.other-suggestions": "",
  "communities.search": "La tua ricerca",
  "communities.see-more": "Vedere altre comunità",
  "community.activity.inactive": "Inattivo",
  "community.all": "Tutte le community",
  "community.already-exists": "Esiste già una comunità con questo nome",
  "community.communities.suggested": "Consigliato per te",
  "community.communities.team-favorite": "❤️ Favorito dell'equipe",
  "community.communities.view-all": "Vedere tutte le comunità",
  "community.creation.suggestion": "",
  "community.date.from-to": "dal {fromDate} al {toDate}",
  "community.description.prayer.success": "Grazie per la tua preghiera!",
  "community.description.read-more": "Leggere il seguito",
  "community.everlasting.unavailable-program": "",
  "community.join-mails.activation": "Si, attivo le emails",
  "community.join-mails.subtitle": "Ti servirà anche da promemoria 😉",
  "community.join-mails.title": "",
  "community.join-next.everlasting.start": "Oggi é stata pubblicata una preghiera nella tua comunità. Voui pregare per questa intenzione ?",
  "community.join-next.no-publication.start": "",
  "community.join-next.pray-now": "",
  "community.join-next.start": "",
  "community.join-next.start-later": "Cominciare più tardi",
  "community.join.card.button": "",
  "community.join.confirmation.in-progress": "Ti sei iscritto alla {lifetime, select, novena {neuvaine} other {retraite}} <strong>in corso</strong>.",
  "community.join.confirmation.soon": "",
  "community.join.confirmation.today": "",
  "community.join.congrats": "Bravo {userName} ! Sei iscritto alla comunità",
  "community.join.congrats.comingSoon": "Bravo {userName} ! Inizierai la {lifetime, select, novena {neuvaine} o il {ritiro}} il {date}",
  "community.join.congrats.ongoing": "Bravo {userName} ! Ti sei iscritto alla {lifetime, select, novena {neuvaine} o {ritiro}} a partire da oggi",
  "community.join.congrats.startToday": "",
  "community.join.date": "Inizia la {lifetime, select, retreat {retraite} novena {neuvaine} other {communauté}} quando preferisci",
  "community.join.date.validate": "Confermo questa data",
  "community.join.error.no-subscription": "",
  "community.join.from-date": "(a partire dal giorno {diffDays})",
  "community.join.infos": "",
  "community.join.invalid-schedule-date": "La data scelta non é valida",
  "community.join.not-schedulable": "Non puoi scegliere una data per questa comunità",
  "community.join.options.title": "",
  "community.join.scheduled-end-date.novena": "La novena finirà il {date}",
  "community.join.scheduled-end-date.retreat": "Il ritiro finirà il {date}",
  "community.join.success.message": "",
  "community.leave-community": "Lasciare la comunità",
  "community.leave.already.left": "Hai già lasciato questa comunità",
  "community.leave.confirm": "",
  "community.leave.fail": "Si é verificato un errore, riprova per favore",
  "community.leave.success": "",
  "community.load.error": "Si é verificato un errore durante il caricamento della comunità",
  "community.not-found": "Questa comunità non esiste",
  "community.not-joined": "Non sei più membro di questa comunità.",
  "community.notifications.activate-push": "Si, attivo le notifiche",
  "community.notifications.receive-publications-push": "",
  "community.notifications.receive-publications-push.subtitle": "",
  "community.private.private": "Privata",
  "community.publication.error.publication.not-accessible": "Questa pubblicazione non é accessibile in questo momento.",
  "community.role.administrator.long": "Sei l'amministratore",
  "community.role.animator.long": "Sei l'animatore",
  "community.role.creator.long": "Sei il creatore",
  "community.share.text": "E se qualcuno dei tuoi conoscenti fosse interessato ? Chiedi allo Spirito Santo di ispirarti 😇",
  "community.status.check.validating": "In corso di validazione",
  "community.status.draft.word": "Brutta",
  "community.tab.description": "Descrizione",
  "community.toolbar.community": "",
  "community.toolbar.stop": "",
  "community.toolbar.title": "Spazio animatore",
  "community.unavailable-program": "",
  "community.unmodifiable": "Non puoi modificare questa comunità",
  "communityAnnouncement.community.user.not-allowed": "Non sei autorizzato ad inviare messaggi ai membri di questa comunità",
  "communityAnnouncement.message.too-long": "Il tuo annuncio é troppo lungo !",
  "communityAnnouncement.subject.too-long": "L'oggetto del tuo annuncio é troppo lungo !",
  "contact.captcha_v2.title": "",
  "contact.email.invalid": "",
  "contact.firstname.invalid": "",
  "contact.firstname.placeholder": "",
  "contact.firstname.tooLong": "",
  "contact.lastname.invalid": "",
  "contact.lastname.label": "",
  "contact.lastname.placeholder": "",
  "contact.load.error": "Si é prodotto un errore durante la ricerca del tuo destinatario.",
  "contact.message.alert": "",
  "contact.message.invalid": "",
  "contact.message.label": "",
  "contact.message.tooShort": "",
  "contact.send-message": "Inviare un messaggio",
  "contact.subject.invalid": "",
  "contact.subject.label": "",
  "contact.subject.placeholder": "",
  "contact.subtitle": "",
  "contact.success.toast": "",
  "content.forbidden-content": "Questo contenuto non é valido",
  "content.invalid": "Il contenuto non é valido o é vuoto",
  "content.invalid-contain-email": "La tua intenzione non deve contenere emails",
  "content.invalid-contain-url": "La tua intenzione non deve contenere link",
  "content.required": "Contenuto mancante",
  "content.too-long": "Questo testo é troppo lungo. Utilizza solo lettere o cifre",
  "content.too-short": "Il testo é troppo corto. Utilizza solo lettere o cifre",
  "conversation.ambiguous-definition": "",
  "conversation.block": "Bloccare la conversazione",
  "conversation.few-seconds": "",
  "conversation.mark-as-unread": "",
  "conversation.not-found": "Questa conversazione é inesistente",
  "conversation.unblock": "Sbloccare la conversazione",
  "conversation.user.not-allowed": "",
  "conversation.you-blocked": "",
  "conversations.unread": "",
  "cta.share": "",
  "dates.invalid": "",
  "description.forbidden-content": "",
  "description.invalid": "",
  "description.required": "",
  "description.too-long": "",
  "description.too-short": "",
  "device.delete.not.found": "",
  "draft.conflict": "",
  "email.already-exists": "",
  "email.invalid": "",
  "email.user.not-found": "",
  "error.403.title": "",
  "error.404.message": "Trova comunità che possano aiutarti a pregare",
  "error.404.quote": "Cercate il Signore, mentre si fa trovare, \ninvocatelo, mentre è vicino. \nIsaia 55:6",
  "error.404.title": "Ci dispiace, questa pagina non esiste su Hozana…",
  "favorite.not-found": "",
  "file.not-an-image": "",
  "fraternity.gender.question": "",
  "fraternity.gender.title": "",
  "fraternity.join.already-have": "",
  "fraternity.join.already-have-description": "",
  "fraternity.join.find": "",
  "fraternity.join.find-description": "",
  "fraternity.join.subtitle": "",
  "fraternity.join.title": "",
  "fraternity.lead.accept": "",
  "fraternity.lead.decline": "",
  "fraternity.lead.description": "",
  "fraternity.lead.learn-more": "",
  "fraternity.lead.title": "",
  "fraternity.onboarding.close.body": "",
  "fraternity.onboarding.close.footer": "",
  "fraternity.onboarding.close.title": "",
  "fraternity.place.city-label": "",
  "fraternity.place.hint": "",
  "fraternity.place.nearby": "",
  "fraternity.place.nearby-description": "",
  "fraternity.place.remote": "",
  "fraternity.place.remote-description": "",
  "fraternity.place.title": "",
  "fraternity.presentation.item.encourage": "",
  "fraternity.presentation.item.pray": "",
  "fraternity.presentation.item.share": "",
  "fraternity.presentation.subtitle": "",
  "fraternity.presentation.title": "",
  "fraternity.ready.eager-no": "",
  "fraternity.ready.eager-yes": "",
  "fraternity.ready.subtitle": "",
  "fraternity.ready.title": "",
  "fraternity.recap.cta": "",
  "fraternity.recap.lead": "",
  "fraternity.recap.place": "",
  "fraternity.recap.sex": "",
  "fraternity.recap.subtitle": "",
  "fraternity.recap.title": "",
  "fraternity.step-label": "",
  "fromDate.in-the-futur": "",
  "fromDate.in-the-past": "",
  "getCommunitiesJoined.user.not-found": "",
  "getCommunitiesWithRole.user.not-found": "",
  "getCommunityNotifications.subscriptionId.not-found": "",
  "guestName.required": "",
  "guestName.too-long": "",
  "guide.not-found": "",
  "hash.invalid": "",
  "hash.required": "",
  "home.faq.title.head": "Come funziona?",
  "home.welcome.app-section.title": "",
  "home.welcome.intentions.title": "",
  "iframe.error.description": "",
  "iframe.error.title": "",
  "intention.anonymous-praying": "",
  "intention.answer.uplift": "",
  "intention.arrival.just-joined": "",
  "intention.arrival.welcome-pray": "",
  "intention.birthday.celebration": "",
  "intention.birthday.pray": "",
  "intention.birthday.years-old": "",
  "intention.created.description": "",
  "intention.created.success": "La tua intenzione è stata depositata",
  "intention.delete.confirm-message1": "",
  "intention.delete.confirm-message2": "",
  "intention.delete.delete": "",
  "intention.finished.arrival": "",
  "intention.finished.birthday": "",
  "intention.finished.intention": "",
  "intention.finished.prayers": "",
  "intention.finished.thank": "",
  "intention.from": "",
  "intention.invitation-to-pray-for": "{name} raccomanda questa intenzione alle tue preghiere",
  "intention.load.error": "",
  "intention.not-found": "",
  "intention.page.button": "",
  "intention.pray-for": "",
  "intention.prayed.already": "",
  "intention.prayed.already-with": "",
  "intention.prayed.birthday": "",
  "intention.prayed.by": "{count, plural, =0 {Nessuno ha ancora pregato} =1 {{name} ha già pregato} =2 {{otherNames} e {name} hanno già pregato} =3 {{otherNames} e {name} hanno già pregato} =4 {{otherNames}, {name} e un'altra persona hanno già pregato} other {{otherNames}, {name} e altre {remainingCount} persone hanno già pregato}} per questa intenzione",
  "intention.prayed.pray-for-others": "👉🏻 Vorresti pregare per altre intenzioni?",
  "intention.prayed.thanks": "",
  "intention.prayed.with": "🙏 {count} {count, plural, one {persona ha pregato} other {persone hanno pregato}} con te per questa intenzione",
  "intention.prayer.not-found": "",
  "intention.prayer.watchman.activate-notifications": "",
  "intention.prayer.watchman.became-watchman": "",
  "intention.prayer.watchman.become": "",
  "intention.prayer.watchman.engagement.1": "",
  "intention.prayer.watchman.engagement.2": "",
  "intention.prayer.watchman.engagement.3": "",
  "intention.prayer.watchman.fetching": "",
  "intention.prayer.watchman.join": "",
  "intention.prayer.watchman.many-watchmen": "",
  "intention.prayer.watchman.method-reminder": "",
  "intention.prayer.watchman.pray-support": "",
  "intention.prayer.watchman.reminder.by-email": "",
  "intention.prayer.watchman.reminder.by-notification": "",
  "intention.prayers.list.title": "",
  "intention.publish.button": "",
  "intention.reload": "",
  "intention.share": "",
  "intention.time-left": "",
  "intention.title": "",
  "intention.write.here": "",
  "intentions.not-found": "",
  "intentions.title": "",
  "intentions.view": "Visualizza le intenzioni",
  "introduction.forbidden-content": "",
  "introduction.too-long": "",
  "introduction.too-short": "",
  "joinCommunity.community.join.already-finished-community": "",
  "journey.empty.active": "Non hai nessun percorso in corso.",
  "journey.novenas-and-journeys": "Novene e percorsi",
  "journey.prayed.today": "Pregato oggi",
  "journey.see-history": "Cronologia",
  "lang.unsupported": "",
  "language.en": "",
  "language.es": "",
  "language.fr": "",
  "language.it": "",
  "language.pl": "",
  "language.pt": "",
  "leave.confirm.message": "",
  "leave.guides-title": "",
  "leave.pray-differently": "",
  "leave.sign-up-again": "",
  "login.account.disabled": "",
  "login.account.missing": "",
  "login.code-input.check-email": "Controlla il codice ricevuto via email",
  "login.code.required": "Codice obbligatorio",
  "login.csrf.invalid": "La sessione è scaduta, riprova",
  "login.email.invalid": "Indirizzo email non valido",
  "login.email.not-provided": "",
  "login.email.required": "",
  "login.failed": "Il codice non è valido o è scaduto",
  "login.password.required": "",
  "meeting.organizer.place.name-placeholder": "",
  "meeting.organizer.time-invalid": "",
  "meeting.organizer.timeStart-invalid": "",
  "message.automatic-message": "",
  "message.delete": "",
  "message.delete.user.not_allowed": "",
  "message.deleted": "",
  "message.godfather.welcome-message.to-godfather": "",
  "message.godfather.welcome-message.to-godson": "",
  "message.invalid": "",
  "message.list.title": "",
  "message.list.title.conversation": "",
  "message.list.title.cta": "",
  "message.list.title.intention": "",
  "message.prayer-on-arrival.has-thanked-you": "",
  "message.prayer-on-arrival.you-thanked-for": "",
  "message.prayer-on-birthday.has-thanked-you": "",
  "message.prayer-on-birthday.you-thanked-for": "",
  "message.prayer-on-comment.has-prayed-for-you": "",
  "message.prayer-on-comment.you-prayed-for": "",
  "message.prayer-on-intention.thank-you": "",
  "message.prayer-on-intention.thanked-you": "",
  "message.prayer.has-just-prayed-for-you.short-multiple": "",
  "message.prayer.has-just-prayed-for-you.short-single": "",
  "message.prayer.has-prayed-for-you.long": "",
  "message.prayer.you-prayed-for.long": "",
  "message.reported": "",
  "message.suspicious.received": "",
  "message.suspicious.sent": "",
  "message.textarea.help.return": "",
  "message.unselected": "",
  "message.update.user.not_allowed": "",
  "name.exists": "",
  "name.forbidden-content": "",
  "name.invalid": "Nome non valido",
  "name.required": "",
  "name.too-long": "",
  "name.too-short": "",
  "native.push.how-to.reactivate.description": "Facendo clic su \"Sì, attiva le notifiche\", ti guideremo alle impostazioni del tuo iPhone. Ti basterà attivare l'opzione \"Notifiche\" e premere la freccia indietro ⬅️ in alto per tornare.",
  "navigation.confession-link": "Confessarsi",
  "navigation.guides.title": "",
  "navigation.intentions": "",
  "navigation.live-page-link": "",
  "navigation.search": "",
  "notificationEmail.invalid": "",
  "oldPassword.invalid": "",
  "page.gone": "",
  "page.not-found": "",
  "password.required": "",
  "password.too-long": "",
  "payload.bad-content": "",
  "payload.text-too-long": "",
  "pictureFileId.required": "",
  "postIntention.content.too-long": "",
  "pray.amen": "Amen!",
  "pray.comment.title": "",
  "pray.entrust-intention": "",
  "pray.entrust-intention.body": "",
  "pray.i-pray.short": "Prega",
  "pray.intention.arrival.title": "Stai pregando per {userName} che è appena arrivato su Hozana",
  "pray.intention.birthday.title": "È il compleanno di {userName}",
  "pray.intention.community.show": "",
  "pray.intention.publication.done": "",
  "pray.intention.publication.show": "",
  "pray.intention.show": "E ora, vuoi pregare per l'intenzione di {user}?",
  "pray.intention.title": "Stai pregando per l'intenzione di {userName}",
  "pray.pray": "",
  "pray.prayed": "",
  "pray.prayer-sent": "",
  "pray.uplift.description": "",
  "pray.uplift.sent": "",
  "pray.uplift.title": "",
  "pray.write-intention": "",
  "pray.your-intention": "",
  "prayer-space.onboarding.step-1.description": "Tutto il team di Hozana è lieto di presentarti questo nuovo Spazio di Preghiera, pensato per aiutarti a crescere nella fedeltà alla preghiera quotidiana.",
  "prayer-space.onboarding.step-1.title": "Nuovo Spazio di Preghiera!",
  "prayer-space.onboarding.step-2.description": "Ritrova facilmente le novene e i percorsi che stai seguendo e visualizza i tuoi progressi!",
  "prayer-space.onboarding.step-2.title": "Segui le tue Novene e i tuoi Percorsi",
  "prayer-space.onboarding.step-3.description": "Ritrova le tue preghiere quotidiane nella sezione «Ogni giorno»: il Vangelo del giorno, la Liturgia delle Ore, le preghiere con il santo del giorno e molto altro.",
  "prayer-space.onboarding.step-3.title": "Ritrova le tue preghiere quotidiane",
  "prayer-space.onboarding.step-4.description": "Nella sezione «Potrebbe interessarti», scopri le proposte del momento e riscopri le novene e i percorsi che hai pregato con piacere.",
  "prayer-space.onboarding.step-4.title": "Scopri la ricchezza della preghiera su Hozana",
  "prayer-space.welcome.discover": "",
  "prayer-space.welcome.end-paragraph": "",
  "prayer-space.welcome.paragraph": "",
  "prayerContent.invalid": "",
  "prayerContent.too-long": "",
  "prayerName.invalid": "",
  "prayerName.required": "",
  "prayerName.too-long": "",
  "prayerSample.not-found": "",
  "publication.already-exists": "",
  "publication.comment.loadmore": "",
  "publication.comment.loadmoreanswers": "",
  "publication.comment.show": "",
  "publication.comment.title": "",
  "publication.favorite.add": "",
  "publication.favorite.remove": "",
  "publication.favorite.removed": "",
  "publication.favorite.success": "",
  "publication.frequency.type.daily": "",
  "publication.frequency.type.long.daily": "",
  "publication.frequency.type.long.monthly": "",
  "publication.frequency.type.long.sporadically": "",
  "publication.frequency.type.long.weekly": "",
  "publication.frequency.type.monthly": "",
  "publication.frequency.type.sporadically": "",
  "publication.frequency.type.weekly": "",
  "publication.goto": "",
  "publication.load.error": "",
  "publication.not-found": "",
  "publication.prayed": "",
  "publication.prayed-by": "",
  "publication.prayed.share.body": "",
  "publication.prayed.share.button": "",
  "publication.prayed.share.choose.body": "",
  "publication.prayed.share.choose.title": "",
  "publication.prayed.share.community.button": "",
  "publication.prayed.share.community.modal.title": "",
  "publication.prayed.share.publication.button": "",
  "publication.prayed.share.publication.modal.title": "",
  "publication.prayed.share.title": "",
  "publication.update": "",
  "publicationFrequencyType.required": "",
  "publicationFrequencyValue.invalid": "",
  "publicationFrequencyValue.required": "",
  "push.allow.message": "",
  "push.blocked.how-to.reactivate": "",
  "push.blocked.how-to.settings.allow": "",
  "push.blocked.how-to.settings.find-hozana": "",
  "push.blocked.how-to.settings.find-list": "",
  "push.blocked.how-to.settings.icon": "",
  "push.blocked.how-to.url-icon.allow": "",
  "push.blocked.how-to.url-icon.browser": "",
  "push.blocked.how-to.url-icon.click": "",
  "push.blocked.message": "",
  "push.blocked.support-link": "",
  "push.blocked.title": "",
  "reportAbuse.reason.required": "",
  "reportAbuse.type.invalid": "",
  "resetPassword.token.invalid": "",
  "role.invalid": "",
  "rosario.bloc.cta": "",
  "rosario.bloc.description.1": "",
  "rosario.bloc.description.2": "",
  "rosario.bloc.description.3": "",
  "rosario.bloc.title": "",
  "rosario.xmrpms.cta": "",
  "rosario.xmrpms.description": "",
  "rosario.xmrpms.objective": "",
  "rosario.xmrpms.title": "",
  "scheduledTime.invalid": "",
  "score-threshold-not-met": "",
  "sendMessage.payload.bad-content": "",
  "settings.account.birthdate": "",
  "settings.account.confirm-password": "",
  "settings.account.current-password": "",
  "settings.account.delete": "",
  "settings.account.delete.confirm": "",
  "settings.account.delete.error-input": "",
  "settings.account.delete.input": "",
  "settings.account.new-password": "",
  "settings.card.community.announce": "",
  "settings.card.community.announce.details": "",
  "settings.card.community.prayer": "",
  "settings.card.notifs.email": "",
  "settings.card.notifs.push": "",
  "settings.email.disable.all": "",
  "settings.header.notifications": "",
  "settings.input.email-is-not-valid": "",
  "settings.input.name-is-not-email": "",
  "settings.input.password.label": "",
  "settings.input.password.social-connect": "",
  "settings.input.title.placeholder": "",
  "settings.language.title": "",
  "settings.notifications.community-registration.title": "",
  "settings.notifications.disable.all": "",
  "settings.notifications.end-of-novena.title": "",
  "settings.notifications.general.description": "",
  "settings.notifications.general.title": "",
  "settings.notifications.incriptions.title": "",
  "settings.notifications.intention-end-time.title": "",
  "settings.notifications.invited-join.title": "",
  "settings.notifications.message.title": "",
  "settings.notifications.newsletter.title": "",
  "settings.notifications.no-ongoing-community.title": "",
  "settings.notifications.pray-remind.title": "",
  "settings.notifications.watchman-remind.title": "",
  "settings.unsubscribe-presubscriber.error": "",
  "settings.unsubscribe-presubscriber.success": "",
  "share.community": "",
  "share.community.share": "",
  "share.copied-link": "",
  "share.copy-link": "",
  "share.intention.email-body": "",
  "share.intention.share": "",
  "share.my.intention.email-body": "",
  "share.publication.email-body": "",
  "share.share": "",
  "share.share-by-email": "",
  "share.share-by-email-body": "",
  "share.wording.send-email": "",
  "share.wording.share-on-whatsapp": "",
  "signup.captcha.required": "",
  "signup.code.invalid": "Il codice non è valido o è scaduto",
  "signup.email.exists": "Esiste già un account con questo indirizzo email",
  "signup.email.invalid": "",
  "signup.email.required": "",
  "signup.fail": "",
  "signup.name.invalid": "",
  "signup.name.required": "",
  "signup.password.required": "",
  "startConversation.payload.bad-content": "",
  "startConversation.user.not-found": "",
  "tab.discover": "",
  "tab.error.generic-description": "",
  "tab.error.try-again": "",
  "tab.messaging": "",
  "tab.prayer-space": "",
  "tag.not-found": "",
  "timeout-or-duplicate": "",
  "token.expired": "",
  "token.required": "",
  "uplift.answer.error": "",
  "uplift.message": "",
  "user.avatar.logo": "",
  "user.communities": "",
  "user.communities.other": "",
  "user.delivery-issue-email.alert-message": "",
  "user.delivery-issue-email.hard-bounce-invalid": "",
  "user.delivery-issue-email.spam-report": "",
  "user.delivery-issue-email.verify-email": "",
  "user.happy-birthday.psalm": "",
  "user.happy-birthday.reference": "",
  "user.happy-birthday.title": "",
  "user.happy-birthday.users-pray-for-you": "",
  "user.happy-birthday.wish": "",
  "user.home-location": "",
  "user.logout.word": "",
  "user.mail.unsubscribe": "",
  "user.not-found": "",
  "user.popins.avatars.choose-my-image": "",
  "user.profile.done-communities": "",
  "user.profile.favorite-publications": "",
  "user.profile.my-profile": "",
  "user.profile.questions.title.wizard": "",
  "user.profile.questions.you-are": "",
  "user.profile.questions.your-birthdate": "",
  "user.profile.questions.your-location": "",
  "user.settings.click-to-fill": "",
  "user.settings.tab.account.password-required": "",
  "user.title.brother": "",
  "user.title.deacon": "",
  "user.title.family": "",
  "user.title.father": "",
  "user.title.miss": "",
  "user.title.mr": "",
  "user.title.mrs": "",
  "user.title.org": "",
  "user.title.sister": "",
  "user.wizard.audio": "",
  "user.wizard.complete": "",
  "user.wizard.minutes": "",
  "user.wizard.my-wizard": "",
  "user.wizard.novena": "",
  "user.wizard.reading": "",
  "user.wizard.video": "",
  "user.wizard.what-themes": "",
  "user.wizard.what-topics": "",
  "watchman.pray-for-today": "",
  "watchman.prayers.thank-you": "",
  "watchman.rely.remains": "",
  "widget.not-found": "",
  "wizard.communityFormats.unknown": "",
  "wizard.communityTypes.unknown": "",
  "wizard.prayerDuration.unknown": "",
  "wizard.tags.unknown": "",
  "word.all.feminine": "",
  "word.cancel": "",
  "word.characters": "",
  "word.choose": "",
  "word.close": "",
  "word.confirm": "",
  "word.congratulations": "",
  "word.continue": "Continua",
  "word.days": "",
  "word.edit": "",
  "word.email": "",
  "word.email-address": "",
  "word.email-address-connection": "",
  "word.email-address-notification": "",
  "word.finish": "",
  "word.in": "",
  "word.intentions": "",
  "word.leave-message": "",
  "word.next": "",
  "word.no": "",
  "word.notifications": "",
  "word.notifications.mails": "",
  "word.prayers": "",
  "word.prayers-count": "",
  "word.previous": "",
  "word.remove": "",
  "word.save": "",
  "word.send": "",
  "word.skip": "",
  "word.today": "Oggi",
  "word.validate": "",
  "word.watchman": "",
  "word.whats-next": "",
  "word.yes": "",
  "word.yesterday": "Ieri",
  "word.you": "",
  "word.your-firstname": "Nome",
  "word.your-title": "",
  "wording.i-share": "",
  "words.a-man": "",
  "words.a-woman": "",
  "words.answer": "",
  "words.by-user": "",
  "words.click-here": "",
  "words.contact-us": "Contattaci",
  "words.done": "",
  "words.home-page": "",
  "words.i-check": "",
  "words.i-subscribe": "Mi iscrivo",
  "words.in-nb-days": "",
  "words.in-nb-days-begin": "",
  "words.nb-days": "{nbDays} {nbDays, plural, one {giorno} other {giorni}}",
  "words.no-thanks": "",
  "words.no-thanks2": "",
  "words.not-now": "",
  "words.ongoing": "",
  "words.profile": "",
  "words.see": "",
  "words.see-all.plur-fem": "",
  "words.see-all.sing": "",
  "words.terms-of-use": "Condizioni di utilizzo",
  "words.thank": "",
  "words.thanked": "",
  "words.your-email-address": "",
  "words.your-intention": "",
  "words.your-message": ""
}
